import { useEffect, useState } from 'react';
import * as variables from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export function useMobile(): { isMobile: boolean } {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' &&
      window.innerWidth < variables.desktop_breakpoint
  );

  useEffect(() => {
    function handleWindowSizeChange(e: Event): void {
      const target = e.target as Window;
      if (target.window.innerWidth < variables.desktop_breakpoint) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
    window.addEventListener('resize', handleWindowSizeChange);
    return () => window.removeEventListener('resize', handleWindowSizeChange);
  }, []);

  return { isMobile };
}
